import { useState, useEffect, useCallback } from 'react';
import {
    initYouTubeCache,
    getAllVideos,
    getVideosForPage,
    subscribeToYouTubeCache,
    forceRefresh,
} from '../services/youtubeService';

/**
 * Hook for consuming YouTube video data.
 * Initializes the cache on first use and subscribes to updates.
 * @param {string|null} pageName - Optional page name to filter videos for contextual links
 * @returns {{ videos: Array, loading: boolean, refresh: Function }}
 */
export function useYouTubeVideos(pageName = null) {
    const [videos, setVideos] = useState(() => {
        return pageName ? getVideosForPage(pageName) : getAllVideos();
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        initYouTubeCache().then(() => {
            const current = pageName ? getVideosForPage(pageName) : getAllVideos();
            setVideos(current);
            setLoading(false);
        });

        const unsubscribe = subscribeToYouTubeCache(() => {
            const updated = pageName ? getVideosForPage(pageName) : getAllVideos();
            setVideos(updated);
            setLoading(false);
        });

        return unsubscribe;
    }, [pageName]);

    const refresh = useCallback(() => forceRefresh(), []);

    return { videos, loading, refresh };
}
